import React, { useState } from "react";
import { Box, Button, Card, CardActions, CardContent, CardHeader, CardMedia, IconButtonProps, MobileStepper, Typography } from "@mui/material";
import { CatalogItem } from "./catalog.component";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from 'react-swipeable-views-utils';
import noImage from '../../../assets/img/no_image.jpg';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

interface ItemProps {
    item: CatalogItem;
    setSelectedReward: (reward: CatalogItem) => void;
}

const ItemCard: React.FC<ItemProps> = ({item, setSelectedReward}: ItemProps) => {

    const [index, setIndex] = useState<number>(0);

    return (
        <Card sx={{ maxWidth: 300, minWidth: 300, height: 500, margin: 2, display: 'flex', flexDirection: 'column' }}>
            <CardHeader
                title={item.name}
            />

            <Box sx={{ width: '100%', height: 194, overflow: 'hidden' }}>


                <MobileStepper
                    steps={item?.medias?.length}
                    position="static"
                    variant="progress"
                    activeStep={index}
                    sx={{ backgroundColor: 'transparent', justifyContent: 'center', cursor: 'pointer' }}
                    nextButton={null}
                    backButton={null}                    
                />

                <AutoPlaySwipeableViews index={index} onChangeIndex={setIndex} enableMouseEvents interval={3000}>
                    {item?.medias?.map((mediaName, idx) => (
                        <CardMedia
                            key={idx}
                            component="img"
                            height="194"
                            image={`${process.env.REACT_APP_API_URL}/rewards/image/${mediaName}`}
                            alt={'Imagem do produto'}
                            onError={(e: any) => {
                                e.target.src = noImage;
                            }}
                        />
                    ))}

                </AutoPlaySwipeableViews>

            </Box>
            
            <CardContent
                sx={{
                    flexGrow: 1, 
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 3
                    }}
            >
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {item.description}
                </Typography>
            </CardContent>
            <div style={{ marginTop: 'auto' }}>
                <CardContent>
                    <Typography variant="h6" color="textPrimary">
                        {item.points} pontos
                    </Typography>
                </CardContent>

                <CardActions disableSpacing>
                    <Button type={'button'} variant={'contained'}
                        style={{width: '100%', backgroundColor: '#D89274'}} size="small" onClick={() => setSelectedReward(item)}>Resgatar</Button>
                </CardActions>
            </div>
        </Card>
    );
}

export { ItemCard }